/*
 * Avisos de cambios. Fuera del rail (se llega por ⌘K): se configura una vez por
 * dispositivo, no es un destino de trabajo.
 *
 * Con los avisos activos, cada cambio que haga otra persona del equipo (una
 * interacción, un hallazgo verificado, un cobro…) llega como notificación del
 * sistema, aunque la app esté cerrada. En iPhone solo funciona con la app instalada
 * en la pantalla de inicio (Compartir → Agregar a inicio), iOS 16.4+.
 */

import { useEffect, useState } from "react";

import { activarAvisos, appInstalada, desactivarAvisos, pushSoportado, suscripcionActual } from "../api/push";
import { useAvisos } from "../shell/Aviso";

export function Notificaciones() {
  const { avisar } = useAvisos();
  const [permiso, setPermiso] = useState(() => ("Notification" in window ? Notification.permission : "default"));
  const [activos, setActivos] = useState<boolean | null>(null);
  const [ocupado, setOcupado] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    suscripcionActual().then((s) => setActivos(s !== null && Notification.permission === "granted")).catch(() => setActivos(false));
  }, []);

  const cambiar = async () => {
    setError(""); setOcupado(true);
    try {
      if (activos) { await desactivarAvisos(); setActivos(false); avisar("Avisos desactivados en este dispositivo"); }
      else { await activarAvisos(); setActivos(true); avisar("Avisos activados en este dispositivo"); }
    } catch (e) {
      setError(e instanceof Error ? e.message : "No se pudo cambiar los avisos.");
    } finally {
      setPermiso("Notification" in window ? Notification.permission : "default");
      setOcupado(false);
    }
  };

  const filas: [string, boolean, string][] = [
    ["Navegador compatible", pushSoportado(), "Este navegador no tiene Web Push. En iPhone hace falta iOS 16.4 o más nuevo."],
    ["Instalada como app", appInstalada(), "En iPhone: Compartir → Agregar a inicio, y abre Nexlum desde ese ícono."],
    ["Permiso para notificar", permiso === "granted", permiso === "denied" ? "Bloqueado. Actívalo en Ajustes → Notificaciones → Nexlum." : "Se pide al activar los avisos."],
  ];

  return (
    <div className="pagina" style={{ maxWidth: 640 }}>
      <h1 className="titulo">Avisos de cambios</h1>
      <p style={{ color: "var(--muted)", fontSize: 13.5, marginTop: 4 }}>
        Recibe una notificación cada vez que alguien más del equipo cambia algo en Nexlum OS: una interacción, un hallazgo, una tarea, un cobro. Tus propios cambios no te avisan. Se activa en cada dispositivo por separado.
      </p>

      <div className="tarjeta" style={{ marginTop: 20, padding: 0 }}>
        {filas.map(([label, ok, ayuda], i) => (
          <div key={label} style={{ display: "flex", gap: 12, padding: "12px 18px", borderTop: i ? "1px solid var(--border)" : "none" }}>
            <span style={{ color: ok ? "var(--verified)" : "var(--faint)", fontWeight: 600, width: 16 }}>{ok ? "✓" : "·"}</span>
            <span style={{ minWidth: 0 }}>
              <span style={{ display: "block", fontSize: 14, fontWeight: 500 }}>{label}{ok ? "" : " — pendiente"}</span>
              {!ok && <span style={{ display: "block", fontSize: 12.5, color: "var(--muted)", marginTop: 2 }}>{ayuda}</span>}
            </span>
          </div>
        ))}
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 12, marginTop: 20 }}>
        <button className={activos ? "btn btn-secundario" : "btn btn-primario"} style={{ padding: "10px 18px", fontSize: 14 }}
          disabled={!pushSoportado() || activos === null || ocupado} onClick={() => void cambiar()}>
          {activos ? "Desactivar avisos" : "Activar avisos"}
        </button>
        {activos && <span style={{ fontSize: 13, color: "var(--verified)" }}>Activos en este dispositivo</span>}
      </div>
      {error && <p style={{ fontSize: 13, color: "var(--risk)", marginTop: 10 }}>{error}</p>}
    </div>
  );
}
